export default "__VITE_ASSET__BuhYVgSC__"